import urlHelper from '@/config/url'
import Cti from '@/models/Cti'
import announcementSocket from '@/libs/sockets/announcements'

const state = {
  isLoggedIn: false,
  phoneNumber: JSON.parse(localStorage.getItem('phoneNumber')),
  extension: JSON.parse(localStorage.getItem('extension')),
  dndStatus: '',
  isCtiLoading: false,
  sipChannel: '',
  sipExtension: '',
  isTransfer: false,
  ctiPopUp: 'dialog',
  autoLoginInterval: null
}

const getters = {
  isLoggedIn (state) {
    return state.isLoggedIn
  },
  phoneNumber (state) {
    return state.phoneNumber
  },
  extension () {
    return state.extension
  },
  dndStatus (state) {
    return state.dndStatus
  },
  isCtiLoading (state) {
    return state.isCtiLoading
  },
  sipChannel (state) {
    return state.sipChannel
  },
  sipExtension (state) {
    return state.sipExtension
  },
  isTransfer (state) {
    return state.isTransfer
  },
  ctiPopUp (state) {
    return state.ctiPopUp
  }
}

const mutations = {
  UPDATE_IS_LOGGED_IN (state, value) {
    state.isLoggedIn = value
  },
  SET_PHONE_NUMBER (state, phoneNumber) {
    state.phoneNumber = phoneNumber
  },
  SET_EXTENSION (state, extension) {
    state.extension = extension
  },
  UPDATE_DND_STATUS (state, value) {
    state.dndStatus = value
  },
  UPDATE_IS_CTI_LOADING (state, value) {
    state.isCtiLoading = value
  },
  UPDATE_SIP_CHANNEL (state, sipChannel) {
    state.sipChannel = sipChannel
  },
  UPDATE_SIP_EXTENSION (state, sipExtension) {
    state.sipExtension = sipExtension
  },
  UPDATE_IS_TRANSFER (state, value) {
    state.isTransfer = value
  },
  UPDATE_CTI_POPUP (state, value) {
    state.ctiPopUp = value
  },

  UPDATE_AUTO_LOGIN_INTERVAL (state, value) {
    state.autoLoginInterval = value
  }
}

const actions = {
  updateIsLoggedIn ({ commit }, value) {
    commit('UPDATE_IS_LOGGED_IN', value)
  },
  setPhoneNumber ({ commit }, phoneNumber) {
    commit('SET_PHONE_NUMBER', phoneNumber)
  },
  setExtension ({ commit }, extension) {
    commit('SET_EXTENSION', extension)
  },
  updateDndStatus ({ commit }, status) {
    commit('UPDATE_DND_STATUS', status)
  },
  updateSipChannel ({ commit }, sipChannel) {
    commit('UPDATE_SIP_CHANNEL', sipChannel)
  },
  updateSipExtension ({ commit }, sipExtension) {
    commit('UPDATE_SIP_EXTENSION', sipExtension)
  },
  updateIsTransfer ({ commit }, value) {
    commit('UPDATE_IS_TRANSFER', value)
  },
  updateCtiPopup ({ commit }, value) {
    commit('UPDATE_CTI_POPUP', value)
  },

  async ctiProcess (context, params) {
    if (!params.url) {
      params.url = urlHelper.dbCon
    }

    const data = {
      id: params.id,
      option: params.option,
      data: state.extension
    }

    switch (params.id) {
    case 'register':
      localStorage.setItem('extension', state.extension)
      break
    case 'unregister':
      localStorage.removeItem('extension')
      localStorage.removeItem('phoneNo')
      break
    }

    try {
      return Cti.get(`${params.domain}${params.url}`, data)
    } catch (e) {
      Promise.reject(e.message)
    }
  },

  async ctiLoading (context, params) {
    const data = {
      data: state.extension
    }

    context.commit('UPDATE_IS_CTI_LOADING', true)

    try {

      const response = await Cti.get(`${params.domain}${urlHelper.load}`, data)

      switch (response.data.status.toString()) {
      case '11':
        context.commit('UPDATE_DND_STATUS', 'rest')
        break
      case '21':
        context.commit('UPDATE_DND_STATUS', 'lunch')
        break
      case '31':
        context.commit('UPDATE_DND_STATUS', 'after')
        break
      default:
        context.commit('UPDATE_DND_STATUS', '')
      }
      switch (response.data.exten_status.toString()) {
      case '51':
        context.commit('UPDATE_IS_LOGGED_IN', true)
        params.socket.emit('register', state.extension)

        announcementSocket.getSocket().emit('join_extension_room', { extensionNumber: state.extension })

        // TODO: Move this on a function.
        context.commit('UPDATE_AUTO_LOGIN_INTERVAL', setInterval(() => {
          params.socket.emit('register', context.state.extension)
          // console.log('register emitted from auto login') // TODO: Remove this.
        }, 10000))
        break
      default:
        context.commit('UPDATE_IS_LOGGED_IN', false)

        announcementSocket.getSocket().emit('leave_extension_room', { extensionNumber: state.extension })

        // TODO: Move this on a function.
        clearInterval(context.state.autoLoginInterval)
        context.commit('UPDATE_AUTO_LOGIN_INTERVAL', null)
      }

      context.commit('UPDATE_IS_CTI_LOADING', false)

    } catch (e) {
      // console.log(e.message)
      // Promise.reject(e.message)
    }

  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
